import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useDispatch } from "react-redux";
import {
  processShareToken,
  processShortShareToken,
  validateShareToken,
  validateShortShareToken,
} from "../../store/usersSlice";
import "./ShareAccessPage.css";
import { OrbitProgress } from "react-loading-indicators";
import { setRedirectingFromSharing } from "../../store/appSlice";

function getQueryParam(search, param) {
  const params = new URLSearchParams(search);
  return params.get(param);
}

const ShareAccessPage = () => {
  const navigate = useNavigate();
  const {
    loginFromShared,
    setSharedToken,
    showReleaseNotes,
    setShowReleaseNotes,
  } = useAuth();
  const location = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    sharingProcess();
  }, []);

  const sharingProcess = async () => {
    const token = getQueryParam(location.search, "token");
    const userToken = localStorage.getItem("access_token");

    const validateAction =
      token.length < 20 ? validateShortShareToken : validateShareToken;
    const processAction =
      token.length < 20 ? processShortShareToken : processShareToken;

    dispatch(validateAction(token)).then((res) => {
      if (!res.error) {
        dispatch(processAction(token)).then(async (res2) => {
          if (!res2.error) {
            let success;
            if (userToken) {
              success = await loginFromShared(
                userToken,
                res.payload.resourceType,
                res.payload.resourceId
              );
            } else {
              success = false;
            }
            if (res2.payload.releaseNotes) {
              setShowReleaseNotes(true);
            } else {
              setShowReleaseNotes(false);
            }
            if (res.payload.resourceType === "PLAN_VERSION_PRICE") {
              navigate("/home");
              return;
            }
            dispatch(setRedirectingFromSharing(true));
            if (!success) {
              setSharedToken(token);
              const navPath =
                res.payload.role !== "VIEWER"
                  ? "?shared=1"
                  : "?shared=1&role=viewer";
              navigate(res.payload.redirectPath + navPath);
            } else {
              const link = res2.payload.organizationId
                ? res.payload.redirectPath.includes("?")
                  ? `${res.payload.redirectPath}&orgId=${res2.payload.organizationId}`
                  : `${res.payload.redirectPath}?orgId=${res2.payload.organizationId}`
                : res.payload.redirectPath;
              navigate(link);
            }
          }
        });
      } else {
        navigate("/home");
      }
    });
  };

  return (
    <div className="App">
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <OrbitProgress color="#C1C7D4" />
      </div>
    </div>
  );
};

export default ShareAccessPage;
